var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-inline"},_vm._l((_vm.blogs),function(blog){return _c('blog-card',{key:blog.id,staticClass:"my-3",attrs:{"blog":blog}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }